/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // Npm: Apollo client for handling graphql request.

/*
 * GRAPHS
 */
const Index = gql`
  mutation MyMutation($blogId: ID!) {
    DeleteBlogs(blogId: $blogId) {
      message
      status
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
